var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFillFullWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24Zm0-17c.6 0 1 .4 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8c0-.6.4-1 1-1Z",
    fill: "#0F69E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFillFullWidth);
export default __webpack_public_path__ + "static/media/add-fill-full-width.c720d525.svg";
export { ForwardRef as ReactComponent };